import React from "react";
import { usePurchaseEnquiryModel } from "../purchaseEnquiryModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import useGlobalModel from "@/model/globalModel";

export function PageHeader() {
    const {
        searchParam,
        initPgCfg,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = usePurchaseEnquiryModel();
    const { getSelectedDictOne } = useDictModel();
    const { shopAndOrg: { shopType }, allShopDs } = useGlobalModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "询价单号",
            fieldName: "code",
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "单据状态",
            fieldName: "status",
            options: getSelectedDictOne(DictCodeEnmu.PURCHASE_ENQUIRY_STATUS),
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "审批类型",
            fieldName: "approveTypeCode",
            options: getSelectedDictOne(DictCodeEnmu.APPROVAL_TYPE),
        },
        {
            type: SearchTypeEnum.RangePicker,
            fieldName: "",
            placeholder: ["询价日期起始", "询价日期结束"],
            rangePickerFieldName: ["enquiryStartTime", "enquiryEndTime"],
            format: "YYYY-MM-DD",
            span: 6
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "所属站点",
            fieldName: "shopId",
            options: allShopDs,
            disabled: shopType === 0 ? false : true
        }
    ]

    return (
        <>
            <YhPageHeader
                size="small"
                title="采购询价"
                triggerSearch={true}
                searchValues={searchParam as ISearchValue}
                searchFields={searchFields}
                onChange={updateSearchParam}
                handleSearch={(params) => { loadData(initPgCfg, { ...searchParam, ...params }) }}
                handleReset={resetSearchParam}
            />
        </>
    );
}